<template>
  <ServiceDetails />
</template>
<script>
import ServiceDetails from '@/components/dashboard/calibration/ServiceDetails.vue'
export default {
  name: 'CalibrationHost',
  components: {
    ServiceDetails
  }
}
</script>
<style lang="scss" scoped></style>
